var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cloud") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 20.475c0-2.967-2.367-5.369-5.33-5.5 0.037-0.258 0.080-0.515 0.080-0.783 0-3.051-2.497-5.525-5.578-5.525-2.075 0-3.864 1.135-4.825 2.8-0.92-0.663-2.044-1.066-3.269-1.066-3.081 0-5.578 2.474-5.578 5.525 0 0.309 0.042 0.608 0.092 0.903-2.058 0.497-3.592 2.322-3.592 4.513 0 2.573 2.106 4.658 4.703 4.658h18.047v-0.033c2.925-0.172 5.25-2.552 5.25-5.492z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.512 15.496c0.224-3.951 3.532-7.096 7.566-7.096 0.941 0 1.861 0.174 2.727 0.511 1.213-1.22 2.822-1.968 4.544-2.161-0.911-1.644-2.535-2.75-4.403-2.75-1.927 0-3.588 1.179-4.48 2.907-0.855-0.689-1.898-1.107-3.036-1.107-2.861 0-5.18 2.569-5.18 5.737 0 0.321 0.039 0.631 0.085 0.938-1.911 0.516-3.335 2.411-3.335 4.687 0 1.707 0.803 3.2 2.008 4.061 0.043-2.442 1.409-4.607 3.504-5.727z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityCloud);
export default __webpack_public_path__ + "static/media/unity_cloud.b77ee30e9e1234dd7eb45eb147afc970.svg";
export { ForwardRef as ReactComponent };